<svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0)">
    <path
      class="app-accent-lighter"
      d="M10.25 13.9106C10.25 11.1492 12.4886 8.91064 15.25 8.91064H48.8335C51.595 8.91064 53.8335 11.1492 53.8335 13.9106V67.25C53.8335 70.0114 51.595 72.25 48.8335 72.25H15.25C12.4886 72.25 10.25 70.0114 10.25 67.25V13.9106Z"
    />
    <circle cx="37.5" cy="33.5" r="12.5" fill="white" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M37.5 21C44.4036 21 50 26.5964 50 33.5C50 40.4036 44.4036 46 37.5 46C30.5964 46 25 40.4036 25 33.5C25 26.5964 30.5964 21 37.5 21ZM45.5659 26.9072L30.9072 41.5659C34.9989 44.9185 41.0463 44.6851 44.8657 40.8657C48.6851 37.0463 48.9185 30.9989 45.5659 26.9072ZM29.4341 40.0928L44.0928 25.4341C40.0011 22.0815 33.9537 22.3149 30.1343 26.1343C26.3149 29.9537 26.0815 36.0011 29.4341 40.0928Z"
      fill="#484B4D"
    />
    <g clip-path="url(#clip1)">
      <path
        d="M59.6158 16.5459L59.6127 16.5427L46.4961 2.92685L46.494 2.92473L46.2044 2.62402H19.1422C18.1266 2.62517 17.1529 3.04449 16.4347 3.78999C15.7166 4.53548 15.3126 5.54626 15.3115 6.60055V61.9868C15.3126 63.0411 15.7166 64.0519 16.4347 64.7974C17.1529 65.5429 18.1266 65.9622 19.1422 65.9633H56.0767C57.0923 65.9622 58.0661 65.5429 58.7842 64.7974C59.5024 64.0519 59.9063 63.0411 59.9074 61.9868V16.8487L59.6158 16.5459ZM46.7857 6.13787L56.5381 16.2615L46.7857 16.3289L46.7857 6.13787ZM57.9242 61.9868C57.9238 62.4953 57.729 62.9829 57.3826 63.3424C57.0362 63.702 56.5666 63.9042 56.0767 63.9047H19.1422C18.6524 63.9042 18.1827 63.702 17.8363 63.3424C17.49 62.9829 17.2952 62.4953 17.2947 61.9868V6.60057C17.2952 6.09206 17.49 5.60452 17.8363 5.24495C18.1827 4.88538 18.6524 4.68318 19.1422 4.68271H44.8026V17.3667C44.8023 17.5019 44.8278 17.6359 44.8775 17.7609C44.9273 17.8859 45.0003 17.9994 45.0924 18.0951C45.1846 18.1907 45.294 18.2665 45.4144 18.3182C45.5348 18.3698 45.6639 18.3962 45.7941 18.396H45.8006L57.9242 18.3108V61.9868Z"
        fill="#484B4D"
      />
    </g>
  </g>
  <defs>
    <clipPath id="clip0">
      <rect width="72" height="72" fill="white" />
    </clipPath>
    <clipPath id="clip1">
      <rect width="45.7627" height="64.4704" fill="white" transform="translate(14.4873 2.25)" />
    </clipPath>
  </defs>
</svg>
